

















import Vue from 'vue';
import CustomType from '../src/types/vue';
import Entete from '../src/modules/Header.vue';
import Corps from '../src/modules/Body.vue';
import Formulaire from '../src/modules/Formulaire.vue';
import Baspage from '../src/modules/Footer.vue';

export interface ComponentApp extends Vue {
}

var component: Vue.ComponentOptions<ComponentApp> = {
  name: 'app',
  data() {
    return {
    }
  },
  methods: {
  },
  watch: {
    locale: function(locale){
      this.$language = locale;
    }
  },
  computed:{
    locale: function(){
      return this.$store.state.locale;
    }
  },
  components: {
    Entete,
    Corps,
    Formulaire,
    Baspage
  }
}

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue